<template>
  <!-- 详情页 -->
  <div class="detail main mt10">
    <div class="goods">
      <!-- 商品图片 -->
      <div class="pics">
        <div class="img" v-if="product.pic">
          <img :src="getPhotoB(product.picDef)" width="100%" />
        </div>
        <div style="position: relative;">
          <ul class="img-list">
            <!-- <li class="arrow" @click="toLeft">
            <i class="iconfont icon-zuoqiehuanjiantou" />
            </li>-->
            <ul class="ing-list-box" ref="imgBox">
              <li
                class="img-item"
                v-for="(item, index) in product.picList"
                :key="index"
                @mouseenter="
                  product.picDef = item;
                  activeImg = index;
                "
              >
                <img :src="getPhoto(item)" width="100%" />
              </li>
            </ul>
            <!-- <li class="arrow" @click="toRight">
            <i class="iconfont icon-youqiehuanjiantou" />
            </li>-->
          </ul>
          <div style="position: absolute; left: 0; top: 50px;cursor: pointer;" class="arrow" @click="toLeft">
            <i class="iconfont icon-zuoqiehuanjiantou" />
          </div>
          <div style="position: absolute; right: 0; top: 50px;cursor: pointer;" class="arrow" @click="toRight">
            <i class="iconfont icon-youqiehuanjiantou" />
          </div>
        </div>
      </div>
      <!-- 商品价格信息 -->
      <div class="info">
        <p class="title">{{ product.name }}</p>
        <div class="price-box">
          <p class="old-price" v-if="product.unitPriceShow">
            <span class="price-title">原价：</span>
            <span class="old-price-value">￥{{ numberFormat(product.unitPriceShow) }}</span>
          </p>
          <p class="new-price">
            <span class="price-title">实际售价：</span>
            <span class="new-price-value">￥{{ numberFormat(product.unitPrice) }}</span>
          </p>
        </div>
        <div class="sort" v-if="sortList.length > 0">
          <span class="sort-title">选择种类</span>
          <ul>
            <li
              :class="productId === item.skus[0] ? 'active' : ''"
              @click="changeSort(item)"
              v-for="(item, index) in sortList"
              :key="index"
            >
              {{ item.value }}
            </li>
          </ul>
        </div>
        <div class="address">
          <!-- <span class="address-title">配送至</span> -->
          <!-- <expertAddress style="display: inline-block;width: 250px;" @addressChange="addressChange"/> -->
          <span class="address-title">商品库存数量</span>
          <span class="cargo">{{ stockNum }}</span>
          <!--  <span class="cargo" v-show="isStock">有货</span>
          <span class="cargo" style="color: red;" v-show="!isStock">缺货</span> -->
          <!-- <span class="cargo-num">商品编号：123456789</span> -->
        </div>
        <!-- <a href="javascript:;" class="help">货品将如何运送</a> -->
        <div class="contact-us">
          <!-- <span class="contact-us-title">客服电话</span>
          <span>021-1234567</span>-->
        </div>
        <!-- 购买按钮 -->
        <div class="btns">
          <a-input-number size="large" :min="1" :defaultValue="1" @change="numChange" />
          <!-- <button class="buy-now" @click="goOrders">立即购买</button> -->
          <button class="buy-now" @click="buyNow">立即购买</button>
          <button class="join-car" @click="goShoppingCart">
            <img src="../../assets/cart.png" width="22px" style="vertical-align: sub;margin-right: 10px;" />加入购物车
          </button>
        </div>
      </div>
    </div>
    <div class="detail-body pt50">
      <!-- 更多商品 -->
      <div class="body-more mr20">
        <ul style="min-height: 592px;">
          <li class="more-title">热销商品</li>
          <a-empty class="mt50" v-if="data.length === 0" />
          <div v-else>
            <router-link tag="li" v-for="item in data" :key="item.sku" :to="`/product/${item.sku}`">
              <img :src="getPhoto1(item.picDef)" width="100px" height="100px" />
              <div class="more-good-info ml10">
                <p class="title">{{ item.name }}</p>
                <p class="price">￥{{ numberFormat(item.unitPrice) }}</p>
              </div>
            </router-link>
          </div>
        </ul>
      </div>
      <div class="body-info">
        <div class="tabs">
          <span :class="['tabs-item', { 'active-tab': isActive }]" @click="isActive = true">商品详情</span>
          <!-- <span :class="['tabs-item',{'active-tab': !isActive}]" @click="isActive = false">包装与规格</span> -->
          <div v-show="!isActive" class="tabs-content">
            <div class="param" v-for="(param, index) in product.param" :key="index">
              <span class="param-key">{{ param.key }}：</span>
              <span class="param-val">{{ param.value }}</span>
            </div>
          </div>
          <div v-show="isActive" class="tabs-content">
            <!-- <div class="param" v-for="(param, index) in paramList" :key="index">
              <span class="param-key">{{param.key}}：</span>
              <span class="param-val">{{param.value}}</span>
            </div>-->
            <div v-html="product.contentPc"></div>
            <div style="display: block;font-size:14px;" v-for="(item, index) in product.make" :key="index">
              <p>{{ index + 1 }}：{{ item }}</p>
            </div>
          </div>
        </div>
        <div class="video-box" v-if="product.video">
          <video class="video-style" width="500" height="300" controls>
            <source :src="'http://www.lexiangspace.com/api/sys/fs/' + product.video" type="video/mp4" />
            <source :src="'http://www.lexiangspace.com/api/sys/fs/' + product.video" type="video/ogg" />
            <source :src="'http://www.lexiangspace.com/api/sys/fs/' + product.video" type="video/webm" />
            <object :data="'http://www.lexiangspace.com/api/sys/fs/' + product.video" width="320" height="240">
              <embed :src="'http://www.lexiangspace.com/api/sys/fs/' + product.video" width="320" height="240" />
            </object>
          </video>
        </div>
        <!-- <div class="detail mt20">
          <img v-for="(item, index) in data" :key="index" :src="getPhoto(item.picDef)" width="100%" />
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
// import expertAddress from '@/components/expertAddress'
import { shopSkusDetail, getSimilars, getStock, shopSkusList, getGoodsStock } from '@/serve/shop'
import { addShopCarts } from '@/serve/shopCars'
import { getRd } from '@/serve/home'
import { mixinFormat } from '@/mixins/mixin'
import global from 'global'
import { mapState } from 'vuex'

export default {
  name: 'detail',
  components: {
    // expertAddress
  },
  mixins: [mixinFormat],
  data () {
    return {
      data: [],
      index: 0,
      sortIndex: -1,
      sortList: [],
      isActive: true, // 商品参数是否激活
      productId: '',
      product: {}, // 商品详情
      productNum: 1, // 商品数量
      regionId: '', // 地址最后一级
      isStock: true,
      stockNum: '' // 库存数量
    }
  },
  watch: {
    '$route.params.id' (newVal, oldVal) {
      if (newVal) {
        this.$router.go(0)
        this.getGoodsStock()
      }
    }
  },
  computed: {
    ...mapState({
      loginType: state => state.user.loginType,
      ageStage: state => state.user.ageStage,
      blocTagBlocId: state => state.user.blocTagBlocId
    })
  },
  methods: {
    // 获取当前商品库存数量
    getGoodsStock () {
      let sku = this.$route.params.id
      getGoodsStock(sku)
        .then(res => {
          this.stockNum = res
        })
        .catch(err => {
          this.$message.error(err.data.message)
        })
    },
    // 热销商品数据 且只展示5条
    async getHotGoods () {
      getRd({ page: 0, shoperType: this.loginType, ageStage: this.ageStage, blocTagBlocId: this.blocTagBlocId }).then(res => {
        let tempData = []
        let skus = res.join(',')
        shopSkusList({ skus }).then(data => {
          data.forEach(item => {
            if (tempData.indexOf(item.productId) === -1) {
              tempData.push(item.productId)
              if (this.data.length < 5) {
                this.data.push(item)
              }
            }
          })
        })
      })
    },
    toLeft () {
      if (this.product.picList.length - this.index < 5) return
      this.index++
      this.$refs.imgBox.style.left = -90 * this.index + 'px'
    },
    toRight () {
      if (this.index === 0) return
      this.index--
      this.$refs.imgBox.style.left = -90 * this.index + 'px'
    },
    addressChange (list) {
      this.regionId = list[list.length - 1].value
      let params = {
        regionId: this.regionId,
        skus: {
          num: this.productNum,
          sku: this.productId
        }
      }
      getStock(params).then(res => {
        console.log('是否有货', res)
      })
    },
    // 切换商品类型
    changeSort (item) {
      this.$router.push({ path: item.skus[0] })
      // this.$router.go(0)
    },
    // 获取图片
    getPhoto (pics) {
      let tempList = pics.split(',')
      return global.file.url + '/sys/fs/' + tempList[0] + '?s=3'
    },
    getPhotoB (pics) {
      let tempList = pics.split(',')
      return global.file.url + '/sys/fs/' + tempList[0] + '?s=5'
    },
    getPhoto1 (pics) {
      let tempList = pics.split(',')
      return global.file.url + '/sys/fs/' + tempList[0] + '?s=2'
    },
    // 立即购买
    buyNow () {
      if (this.productNum > this.stockNum) {
        return this.$message.error('当前数量不能大于库存数，请重新修改数量')
      }
      this.$router.push({ path: '/ordersPay', query: { skuId: this.product.sku, num: this.productNum } })
    },
    // 加入购物车
    goShoppingCart () {
      if (this.productNum > this.stockNum) {
        return this.$message.error('当前数量不能大于库存数，请重新修改数量')
      }
      addShopCarts(this.product.sku, { num: this.productNum })
        .then(() => {
          this.$message.success('加入购物车成功')
          // this.$router.push({ path: '/shoppingCart' })
        })
        .catch(() => {
          this.$message.error('操作失败')
        })
    },
    onChange (value) {
      console.log('value', value)
    },
    // 购买数量
    numChange (val) {
      if (val > this.stockNum) {
        this.$message.error('当前数量不能大于库存数，请重新修改数量')
      }
      this.productNum = val
    },
    // init () {
    //   this.productList.forEach(item => {
    //     if (item.productId === this.productId) {
    //       this.product = item
    //       this.tabsImgs.push({ url: item.pic[0] })
    //     }
    //   })
    // },
    // 获取商品详情
    getShopSkusDetail () {
      shopSkusDetail(this.productId).then(res => {
        this.product = res
        this.product.picList = res.pic.split(',')
        this.product.picList.unshift(res.picDef)
        getSimilars(res.sku).then(res1 => {
          res1.length > 0 ? (this.sortList = res1[0].values) : (this.sortList = [])
        })
      })
    },
    getStock () {
      let params = {
        regionId: '',
        skus: [
          {
            num: 1,
            sku: this.productId
          }
        ]
      }
      getStock(params).then(res => {
        if (res[0].stock === 'STOCK_OUT') {
          this.isStock = false
        } else {
          this.isStock = true
        }
      })
    }
  },
  created () {
    this.productId = this.$route.params.id
    // this.init()
    this.getShopSkusDetail()
    this.getHotGoods()
    this.getGoodsStock() // 获取库存数量
    // this.getStock()
  }
}
</script>
<style lang="less" scoped>
.detail {
  .goods {
    display: flex;
    .pics {
      width: 400px;
      height: 400px;
      margin-right: 30px;
      .img {
        height: 100%;
        overflow: hidden;
      }
      .img-list {
        padding-left: 0;
        // width: 200%;
        height: 80px;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        width: 360px;
        overflow: hidden;
        margin-left: 20px;
        // overflow: hidden;
        li {
          display: inline-block;
        }

        .arrow {
          cursor: pointer;
          img {
            width: 20px;
          }
        }
        .ing-list-box {
          padding-left: 0;
          // width: 200%;
          overflow: hidden;
          height: 100%;
          padding-top: 5px;
          white-space: nowrap;
          position: absolute;
          left: 0px;
          .img-item {
            width: 70px;
            height: 70px;
            overflow: hidden;
            border: 1px solid #ccc;
            margin: 0 10px;
          }
        }
      }
    }
    .info {
      width: 760px;
      min-height: 463px;
      .title {
        font-size: 18px;
        color: #333;
      }
      .price-box {
        padding: 20px 10px;
        background: #f5f4f4;
        .old-price,
        .new-price {
          .price-title {
            color: #a2a2a2;
          }
          .old-price-value {
            font-size: 16px;
            font-weight: 700;
            color: #a5a3a3;
            text-decoration-line: line-through;
          }
          .new-price-value {
            font-size: 32px;
            font-weight: 700;
            color: #e84a4a;
          }
        }
      }
      .sort {
        border-bottom: 1px solid #ccc;
        ul {
          display: inline-block;
          padding-left: 0px;
          margin: 0;
          li {
            display: inline-block;
            border: 1px solid #ccc;
            padding: 5px 10px;
            margin-right: 10px;
            cursor: pointer;
            &:hover {
              border-color: #e69b47;
              color: #e69b47;
            }
          }
          .active {
            border-color: #e69b47;
            color: #e69b47;
          }
        }
      }
      .address {
        .cargo {
          padding: 0 10px;
          // border-right: 1px solid #ccc;
        }
        .cargo-num {
          padding-left: 10px;
        }
      }
      .contact-us {
        border-bottom: 1px solid #ccc;
      }
      .sort,
      .address,
      .contact-us {
        padding: 20px 10px;
      }
      .sort .sort-title,
      .address .address-title,
      .contact-us .contact-us-title {
        display: inline-block;
        width: 80px;
        color: #a5a3a3;
      }
      .help {
        margin-left: 90px;
      }

      .btns {
        margin-top: 20px;
        .buy-now,
        .join-car {
          padding: 10px 0;
          width: 198px;
          text-align: center;
          outline: none;
          font-size: 18px;
          margin-left: 20px;
          cursor: pointer;
          border: none;
        }
        .buy-now {
          background: #fff;
          border: 1px solid #e69b47;
          color: #e69b47;
        }
        .join-car {
          background: #e69b47;
          border-color: #e69b47;
          color: #fff;
        }
      }
    }
  }
  .detail-body {
    display: flex;
    // 更多商品
    .body-more {
      width: 300px;
      display: inline-block;
      ul {
        border: 1px solid #ccc;
        padding-left: 0;
        .more-title {
          font-size: 18px;
          text-align: center;
          color: #fff;
          background: #e69b47;
        }
        li {
          border-bottom: 1px solid #ccc;
          cursor: pointer;
          padding: 5px 10px;
          &:hover .title {
            color: #e69b47;
          }
        }
        img {
          vertical-align: bottom;
        }
        .more-good-info {
          display: inline-block;

          .title {
            width: 140px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .price {
            color: #e84a4a;
            font-size: 20px;
            font-weight: 700;
          }
        }
      }
    }

    .body-info {
      display: inline-block;
      width: 870px;
      .tabs {
        background: #f2f2f2;
        width: 870px;
        font-size: 18px;
        color: #666;
        border: 1px solid #ccc;

        .tabs-item {
          padding: 10px 45px;
          display: inline-block;
          cursor: pointer;
        }

        .active-tab {
          background: #fff;
          border-top: 3px solid #e69b47;
        }

        .tabs-content {
          background: #fff;
          padding: 20px;

          .param {
            font-size: 14px;
            display: inline-block;
            width: 25%;
          }
        }

        .detail {
          width: 870px;
        }
      }
    }
  }
  .video-box {
    width: 870px;
    height: 331px;
    margin-top: 10px;
    border: 1px solid #ccc;
    position: relative;
    .video-style {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
